import { Text, Caption } from '@/shared/components/typography'

interface ParkinglotOperationInfoViewProps {
  operationTime: { key: string; value: string }[]
}

const ParkinglotOperationInfoView = ({ operationTime }: ParkinglotOperationInfoViewProps) => {
  return (
    <div className="h-full w-full">
      <Text level="text3" weight="bold" color="text090">
        운영 시간
      </Text>
      <div className="mt-[16px] flex flex-col items-center justify-center gap-[8px]">
        {operationTime.map(({ key, value }) => (
          <div className="flex w-full items-center justify-between" key={key}>
            <Caption level="caption1" color="text070" weight="regular">
              {key}
            </Caption>
            <Caption level="caption1" color={value === '해당항목없음' ? 'text050' : 'text090'} weight="regular">
              {value === '해당항목없음' ? '정보없음' : value}
            </Caption>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ParkinglotOperationInfoView
